module.exports = __webpack_public_path__ + "img/martini.5c76d744.png";